import AllBase from "bwd-components/base";
import AllArticle from "bwd-components/article";
import AllContent from "bwd-components/content";
import AllInvitation from "bwd-components/invitation";
import AllStructure from "bwd-components/structure";
import AllHotel from "bwd-components/hotel";

const components = {
  ...AllBase,
  ...AllArticle,
  ...AllContent,
  ...AllInvitation,
  ...AllStructure,
  ...AllHotel,
};

export default components;
